import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  HorizontalLine,
  TableHeaderCell,
  TakedownTable,
} from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle } from '../ThreatTable/ThreatExpandedRow.style';
import { formatedDate } from '../../utils';
import { HistoryStatues } from '../../helpers/types';

interface ExpandedStatusHistoryProps {
  title: string;
  statusHistory: HistoryStatues[];
  isLoading: boolean;
}

const ExpandedStatusHistory = ({ title, statusHistory, isLoading }: ExpandedStatusHistoryProps) => {
  const theme = useTheme();

  return (
    <SectionColumn>
      <SectionTitle>{title}</SectionTitle>
      <HorizontalLine sx={{ mb: 1 }} />
      {isLoading ? (
        <Skeleton variant="rectangular" height={80} />
      ) : statusHistory.length > 0 ? (
        <TakedownTable>
          <TableContainer sx={{ maxHeight: 150 }}>
            <Table size="small" sx={{ border: 0 }}>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Status</TableHeaderCell>
                  <TableHeaderCell>User</TableHeaderCell>
                  <TableHeaderCell>Date</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {statusHistory.map((item, index) => (
                  <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
                    <TableCell
                      sx={{ fontSize: '12px', textTransform: 'capitalize', fontWeight: 500 }}>
                      {item.Status}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {item.Username ||
                        (['d', 'o'].includes(item.Process ?? '') ? 'system' : '-')}
                    </TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {`${formatedDate(item.Created)} UTC`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TakedownTable>
      ) : (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.disabled, fontStyle: 'italic' }}>
          No status history
        </Typography>
      )}
    </SectionColumn>
  );
};

export default ExpandedStatusHistory;
